module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs is-toggle is-fullwidth lxm-bottom-tabs"
  }, [_c('ul', [_vm._l((_vm.tabs), function(tab) {
    return [_c('li', {
      staticClass: "lxm-bottom-tabs__li",
      class: {
        'is-active': tab.active
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.tabClicked(tab)
        }
      }
    }, [_c('div', {
      staticClass: "lxm-bottom-tabs__tab"
    }, [_c('div', {
      staticClass: "lxm-bottom-tabs__icon-container"
    }, [_c('div', {
      staticClass: "lxm-bottom-tabs__icon",
      class: _vm.iconClass(tab)
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(tab.name))])])])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "lxm-bottom-tabs-placeholder"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8fd165ec", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8fd165ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmBottomTabs.vue
// module id = 879
// module chunks = 0